export const addValidZipError = 'Please enter a valid zip code!';
export const errorAddingZip = `Error adding zip code!`;
export const successAddingZip = (zipCode) => `Added ${zipCode}`;
export const removedZip = (zipCode) => `Removed zip code: ${zipCode}`;
export const addZipDescription = (regionName) => `Enter a zip code below to add it to ${regionName}.`;
export const errorRemovingZip = 'Error removing zip code!';
export const addZipTitle = 'Add a new zip code';
export const zipCodePlaceholder = 'Zip code...';
export const addZipButton = 'add zip';
export const overlayAddZipTitle = 'Add a zipcode';
export const searchZipsPlaceholder = 'filter zip codes...';
